import { Action, createAction, handleActions } from "redux-actions";
import { calculateDate } from "~libs/dateCalculator";
import { FechaFiltro, FiltroValue, TakeValue } from "../../types";

/**
 * `estado` se guarda como lista porque el backend espera varios estados a la
 * vez; el selector manda uno solo, que puede ser la combinación "todos".
 */
interface FiltrosSolicitudesPendientesSucursalState {
  take: TakeValue;
  page: number;
  fechaDesde: FechaFiltro;
  fechaHasta: FechaFiltro;
  searchCriteria: string;
  estado: FiltroValue[];
}

const setInitialStateSolicitudesPendientesCompania = createAction(
  "SET_INITIAL_STATE_FILTRO_SOLICITUDES"
);

const setPage = createAction(
  "SET_LISTADO_SOLICITUDESEMISION_PAGE",
  (page: number) => ({
    page,
  })
);

const setTake = createAction(
  "SET_LISTADO_SOLICITUDESEMISION_ROWS_PER_PAGE",
  (take: TakeValue) => ({ take })
);

const selectFechaDesde = createAction(
  "SELECT_FECHA_DESDE_FILTRO",
  (fechaDesde: FechaFiltro) => ({ fechaDesde })
);

const selectFechaHasta = createAction(
  "SELECT_FECHA_HASTA_FILTRO",
  (fechaHasta: FechaFiltro) => ({ fechaHasta })
);

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_FILTRO",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const selectEstado = createAction(
  "SELECT_ESTADO_FILTRO",
  (estado: FiltroValue) => ({
    estado,
  })
);

const filtrosSolicitudesInitialState: FiltrosSolicitudesPendientesSucursalState =
  {
    take: 10,
    page: 0,
    fechaDesde: calculateDate(new Date(), -30),
    fechaHasta: new Date(),
    searchCriteria: "",
    estado: ["Pendiente,PendienteCompania,DatosIncompletos"],
  };

const solicitudesPendientesSucursalFiltrosReducer = handleActions<
  FiltrosSolicitudesPendientesSucursalState,
  any
>(
  {
    [setInitialStateSolicitudesPendientesCompania.toString()]:
      (): FiltrosSolicitudesPendientesSucursalState => {
        return {
          ...filtrosSolicitudesInitialState,
        };
      },
    [setPage.toString()]: (
      state: FiltrosSolicitudesPendientesSucursalState,
      action: Action<{ page: number }>
    ): FiltrosSolicitudesPendientesSucursalState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake.toString()]: (
      state: FiltrosSolicitudesPendientesSucursalState,
      action: Action<{ take: TakeValue }>
    ): FiltrosSolicitudesPendientesSucursalState => {
      return {
        ...state,
        take: action.payload.take,
      };
    },
    [selectFechaDesde.toString()]: (
      state: FiltrosSolicitudesPendientesSucursalState,
      action: Action<{ fechaDesde: FechaFiltro }>
    ): FiltrosSolicitudesPendientesSucursalState => {
      return {
        ...state,
        fechaDesde: action.payload.fechaDesde,
      };
    },
    [selectFechaHasta.toString()]: (
      state: FiltrosSolicitudesPendientesSucursalState,
      action: Action<{ fechaHasta: FechaFiltro }>
    ): FiltrosSolicitudesPendientesSucursalState => {
      return {
        ...state,
        fechaHasta: action.payload.fechaHasta,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosSolicitudesPendientesSucursalState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosSolicitudesPendientesSucursalState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [selectEstado.toString()]: (
      state: FiltrosSolicitudesPendientesSucursalState,
      action: Action<{ estado: FiltroValue }>
    ): FiltrosSolicitudesPendientesSucursalState => {
      let estado =
        action.payload.estado !== "Pendiente" &&
        action.payload.estado !== "PendienteCompania" &&
        action.payload.estado !== "DatosIncompletos" &&
        action.payload.estado !== "Pendiente,PendienteCompania,DatosIncompletos"
          ? "Pendiente,PendienteCompania,DatosIncompletos"
          : action.payload.estado;

      return {
        ...state,
        estado: [estado],
      };
    },
  },
  filtrosSolicitudesInitialState
);

export { solicitudesPendientesSucursalFiltrosReducer };
export {
  setPage,
  setTake,
  selectFechaDesde,
  selectFechaHasta,
  selectSearchCriteria,
  setInitialStateSolicitudesPendientesCompania,
  selectEstado,
};
